/*
 *
 * Autocomplete constants
 *
 */

export const CLEAR_OPTIONS = 'claris-vnext/AdvancedForm/Autocomplete/CLEAR_OPTIONS';
export const LOAD_OPTIONS = 'claris-vnext/AdvancedForm/Autocomplete/LOAD_OPTIONS';
export const LOAD_INITIAL_VALUE = 'claris-vnext/AdvancedForm/Autocomplete/LOAD_INITIAL_VALUE';
